function hasSlot(element, name) {
  if (name) {
    return element.querySelector(`:scope > [slot="${name}"]`) !== null;
  }
  return [...element.childNodes].some((node) => {
    if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== "") {
      return true;
    }
    if (node.nodeType === node.ELEMENT_NODE) {
      const element2 = node;
      if (!element2.hasAttribute("slot")) {
        return true;
      }
    }
    return false;
  });
}
export { hasSlot };
